import { render, staticRenderFns } from "./AuditCouponList.vue?vue&type=template&id=538291b4&scoped=true&"
import script from "./AuditCouponList.vue?vue&type=script&lang=ts&"
export * from "./AuditCouponList.vue?vue&type=script&lang=ts&"
import style0 from "./AuditCouponList.vue?vue&type=style&index=0&id=538291b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538291b4",
  null
  
)

export default component.exports